{
  "page_title": "Reset password",
  "heading": "Reset your password",
  "byline": "We'll email you instructions to reset your password.",
  "success": "Check your email for instructions!",
  "error": "Error resetting your password. Please try again.",
  "error_recipient_suppressed": "We can't deliver email to this address, so we couldn't send your reset instructions. This usually means a previous email bounced or was marked as spam. Please contact support to get it sorted out.",
  "inputs": {
    "email": "Email address"
  },
  "buttons": {
    "submit": "Reset password",
    "login": "Return to login"
  }
}
